"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILibraryContentItemType = void 0;
var ILibraryContentItemType;
(function (ILibraryContentItemType) {
    ILibraryContentItemType["Program"] = "program";
    ILibraryContentItemType["Workout"] = "workout";
    ILibraryContentItemType["General"] = "general";
    ILibraryContentItemType["LiveWorkout"] = "live-workout";
    ILibraryContentItemType["Section"] = "section";
    ILibraryContentItemType["Trainer"] = "trainer";
    ILibraryContentItemType["Challenge"] = "challenge";
})(ILibraryContentItemType || (exports.ILibraryContentItemType = ILibraryContentItemType = {}));
//# sourceMappingURL=library-content-item-type.js.map